module.exports = __webpack_public_path__ + "img/calculator-style-4.9ccbb5a2.png";